import React from 'react'
import Image from "../../components/elements/Image"
import Icon from "../../assets/images/icon.png"
import PaymentInterface from "../../components/sections/front/PaymentInterface"
import logo from "../../assets/images/logo.png";


const Buy = () => {
  return (
    <>
      <div className="relative flex py-28 justify-center h-screen ">
        <div className="relative max-w-[420px]  w-full bg-white rounded-2xl px-4 py-5 flex flex-col overflow-hidden z-10">
          <div className="flex  items-center justify-between">
            <div className="w-6 h-6 overflow-hidden">
              <Image
                src={Icon}
                alt=""
                width={100}
                height={100}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-center text-shades-07 font-semibold">Buy crypto</div>
            <div className="w-8 h-8 rounded-full flex  bg-[#556080] text-white  items-end justify-center text-2xl"><i class="fa-solid fa-user"></i></div>
          </div>
          <PaymentInterface />
          <div className="mt-auto mx-auto">
            <Image
              src={logo}
              width={"100%"}
              height={"100%"}
              classes={"max-w-24  w-full "}
            />
          </div>
        </div>
        <div class="absolute inset-0 mx-auto w-[1500px] h-[1500px] rounded-full bg-radial-custom left-0 right-0 z-0"></div> 
      </div>
    </>
  )
}

export default Buy